var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dispute-status"},[_c('span',{staticClass:"dispute-status-name"},[_vm._v("Dispute status")]),_c('Button',{class:[
      'dispute-status-dropdown',
      { 'dispute-status-dropdown--disabled': _vm.disabled },
      _vm.getClassName,
    ],attrs:{"icon":_vm.icon,"label":_vm.disputeStatus.displayName,"disabled":_vm.disabled},on:{"onClick":function($event){return _vm.handleDisputeStatusDropdown($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }